import { ColProps, ContainerProps, RowProps, SectionProps } from 'components/grid/grid.props'
import React from 'react'
import { twMerge } from 'tailwind-merge'

export const Section = ({ children, gray, flatGray, backgroundColor = '', id, full, margin = '', scrollMarginTop, className = '', ...props }: SectionProps) => {
	return (
		<section id={id} className={twMerge('SECTION relative mx-auto pb-10', margin, className, backgroundColor)} style={{ scrollMarginTop: scrollMarginTop }} {...props}>
			{gray && <div className="h-[125px] w-full bg-cover bg-center bg-no-repeat md:h-[225px]" style={{ backgroundImage: 'url(/images/utils/divider-top.svg)' }} />}
			<div className={`WRAPPER ${gray || flatGray ? 'bg-slate-50' : ''}`}>
				<div className={`CONTAINER w-full ${full ? '' : 'mx-auto lg:max-w-screen-lg xl:max-w-screen-xl'}`}>{children}</div>
			</div>
			{gray && <div className="h-[125px] w-full bg-cover bg-center bg-no-repeat md:h-[225px]" style={{ backgroundImage: 'url(/images/utils/divider-bottom.svg)' }} />}
		</section>
	)
}

export const Container = ({ children, gray, white, color }: ContainerProps) => {
	return <div className={`CONTAINER w-full ${gray ? 'bg-slate-50' : ''} ${white ? 'bg-white' : ''} ${color ? 'arc-gradient-light' : ''}`}>{children}</div>
}

export const Row = ({ children, center, middle, className, overflow = true, id, testId, ...props }: RowProps) => {
	return (
		<div
			{...props}
			id={id}
			data-cy={testId}
			className={twMerge('ROW flex flex-wrap', overflow && 'overflow-hidden', center && 'justify-center', middle && 'items-center', className)}
		>
			{children}
		</div>
	)
}

export const Col = ({ children, width = 'w-full', gutter = 'md', className }: ColProps) => {
	let gutters
	if (gutter === 'none') gutters = 'px-0'
	else if (gutter === 'sm') gutters = 'px-2'
	else if (gutter === 'md') gutters = 'px-4'
	else if (gutter === 'lg') gutters = 'px-5'
	else if (gutter === 'xl') gutters = 'px-6'
	else if (gutter === '2xl') gutters = 'px-8'
	else if (gutter === '3xl') gutters = 'px-10'

	return <div className={twMerge('COL', gutters, width, className)}>{children}</div>
}
